import * as React from "react";
const SvgViewSelector = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 3H9V5H5V9H3V3ZM15 3H21V9H19V5H15V3ZM5 15V19H9V21H3V15H5ZM21 15V21H15V19H19V15H21Z", fill: "#666666", style: {
  fill: "#666666",
  fill: "color(display-p3 0.4000 0.4000 0.4000)",
  fillOpacity: 1
} }), /* @__PURE__ */ React.createElement("rect", { x: 9, y: 9, width: 6, height: 6, fill: "#666666", style: {
  fill: "#666666",
  fill: "color(display-p3 0.4000 0.4000 0.4000)",
  fillOpacity: 1
} }));
export default SvgViewSelector;
